define('nls/res',{
  "root": {
  },
  "en": true,
  "es": true
});
